module.exports = __webpack_public_path__ + "static/prettyKal-a56e8b0a9993e2859408db3f00e3df6f.jpg";